'use client';

import { c as _c } from "react/compiler-runtime";
import { OptimizelyDecideOption } from '@optimizely/optimizely-sdk';
import { useEffect } from 'react';
import { useOptimizely } from '@libs/common-next';
const TRACK_AB_TEST_EVENT = 'trackABTestContentSquare';
export function useSyncExperiments() {
  const $ = _c(4);
  const {
    instance,
    context
  } = useOptimizely();
  let t0;
  let t1;
  if ($[0] !== context || $[1] !== instance) {
    t0 = () => {
      if (!instance || !context || typeof window === "undefined") {
        return;
      }
      Object.entries(context.decideAll([OptimizelyDecideOption.DISABLE_DECISION_EVENT])).filter(t2 => {
        const [flagKey, decision] = t2;
        const ruleKey = decision.ruleKey;
        if (!ruleKey || !decision.variationKey) {
          return false;
        }
        const experimentRules = instance.getOptimizelyConfig()?.featuresMap[flagKey]?.experimentRules ?? [];
        return experimentRules.some(experiment => experiment.key === ruleKey);
      }).forEach(_temp);
    };
    t1 = [instance, context];
    $[0] = context;
    $[1] = instance;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function _temp(t0) {
  const [flagKey_0, decision_0] = t0;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({
    event: TRACK_AB_TEST_EVENT,
    optimizely_flag_key: `AB_OP_SS_${flagKey_0}`,
    optimizely_flag_value: decision_0.variationKey
  });
  window.dataLayer.push({
    event: "optimizely_decision_server",
    optimizely_flag_key: flagKey_0,
    optimizely_flag_value: decision_0.variationKey
  });
}